export default "/_next/static/images/37f0a3215da27b0db50b5043e583e1e0.png";